import Model from '@/models/Model'

export default class GCompany extends Model {
    resource() {
        return 'g_company'
    }
}
